import React from 'react';
import PropTypes from 'prop-types';
import { PSPModuleWrapper } from 'components/psp/PSPModuleWrapper';
import { PSPMarkdownContent } from 'components/psp/PSPMarkdown';

// This is a PSP Module, use it for adding a only-text module to a PSP page
// It needs to be imported directly in the Module Factory
export default function PSPMarkdownModule({ content, linkUrl, linkText, additionalProps } ) {
	return (
		<PSPModuleWrapper linkUrl={linkUrl} linkText={linkText}>
			<PSPMarkdownContent content={content} additionalProps={additionalProps}/>
		</PSPModuleWrapper>
	);
}

PSPMarkdownModule.propTypes = {
	content: PropTypes.string,
	linkUrl: PropTypes.string,
	linkText: PropTypes.string,
	additionalProps: PropTypes.object
};
